import React from "react";
import { View, StyleSheet } from "react-native";

import { colors } from "asset/constant";
import { mq } from "utils";

export default function Separator(props: SeparatorT) {
  const {
    align = "center",
    axis = "x",
    color = colors.text.muted,
    sidesSpace = 15,
    size = "100%",
    weight = 1,
    transparent,
  } = props;

  const styles = StyleSheet.create({
    separator: {
      width: axis === "x" ? size : mq(weight),
      height: axis === "y" ? size : mq(weight),
      borderRadius: mq(10),
      ...(axis === "x" && typeof sidesSpace === "number"
        ? { marginVertical: mq(sidesSpace) }
        : {}),
      ...(axis === "y" && typeof sidesSpace === "number"
        ? { marginHorizontal: mq(sidesSpace) }
        : {}),
      ...(sidesSpace && typeof sidesSpace !== "number"
        ? {
            marginTop: mq(sidesSpace.top),
            marginBottom: mq(sidesSpace.bottom),
            marginLeft: mq(sidesSpace.left),
            marginRight: mq(sidesSpace.right),
          }
        : {}),
      backgroundColor: transparent ? "transparent" : color,
      alignSelf:
        align === "center"
          ? "center"
          : align === "start"
          ? "flex-start"
          : "flex-end",
    },
  });

  return <View style={styles.separator} />;
}
